export enum SHARE_TYPE {
  TWITTER = 'TWITTER',
  FACEBOOK = 'FACEBOOK',
  MAIL = 'MAIL',
  WHATSAPP = 'WHATSAPP',
  LINKEDIN = 'LINKEDIN'
}
